import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    bobCorporateActiveButton: {
        name: ""
    },
    selectedCompany: null,
    companyTransferData: {},
    userData: null,
}

const bobCorporateSlice = createSlice({
    name: "bobcorporate",
    initialState,
    reducers: {
        setBobCorporateActiveButton: (state, action) => {
            state.bobCorporateActiveButton = action.payload;
        },
        setSelectedCompany: (state, action) => {
            state.selectedCompany = action.payload;
        },
        setCompanyTransferData: (state, action) => {
            state.companyTransferData = action.payload;
        },
        setUserData: (state, action) => {
            state.userData = { 
                ...state.userData,  
                ...action.payload  
            };
        },
        resetBobCorporateState: (state) => {
            // state.selectedCompany = null;
            state.companyTransferData = {};
            state.userData = null;
            state.bobCorporateActiveButton = state.bobCorporateActiveButton;
        }
        
    }
})

export const { setBobCorporateActiveButton, setSelectedCompany, setCompanyTransferData, setUserData, resetBobCorporateState } = bobCorporateSlice.actions;
export default bobCorporateSlice.reducer;
